export const REDIRECT_TO_PARAM = 'redirectTo';
export const REDIRECT_TO_STORAGE_KEY = 'redirectTo';

// URL-resolved, not substring checks: browsers normalize `/\evil.com` to `//evil.com`.
export const isSafeRedirectPath = (path: string | null | undefined): path is string => {
  if (!path?.startsWith('/')) return false;
  try {
    return new URL(path, globalThis.location.origin).origin === globalThis.location.origin;
  } catch {
    return false;
  }
};

export const buildSignInUrl = (pathname: string, search = ''): string => {
  if (pathname.startsWith('/sign-in')) {
    // Keep the pending target instead of wiping it on reload.
    const existing = new URLSearchParams(search).get(REDIRECT_TO_PARAM);
    return isSafeRedirectPath(existing) ? `/sign-in?${REDIRECT_TO_PARAM}=${encodeURIComponent(existing)}` : '/sign-in';
  }
  const target = `${pathname}${search}`;
  return `/sign-in?${REDIRECT_TO_PARAM}=${encodeURIComponent(target)}`;
};

// sessionStorage, not a query param: the SSO round-trip returns to a fixed callback URL.
export const stashRedirectTarget = (target: string | null | undefined): void => {
  if (isSafeRedirectPath(target)) {
    sessionStorage.setItem(REDIRECT_TO_STORAGE_KEY, target);
  } else {
    sessionStorage.removeItem(REDIRECT_TO_STORAGE_KEY);
  }
};

export const consumeRedirectTarget = (): string | null => {
  const target = sessionStorage.getItem(REDIRECT_TO_STORAGE_KEY);
  sessionStorage.removeItem(REDIRECT_TO_STORAGE_KEY);
  return isSafeRedirectPath(target) ? target : null;
};

export const clearRedirectTarget = (): void => {
  sessionStorage.removeItem(REDIRECT_TO_STORAGE_KEY);
};
